/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
// This lib is under 1kb gzipped - maybe we move to api later on
import Card from '../../../../components/card/card';
import Slug from '../../../../components/slug/slug';
import FCLink from "../../../../components/fc_link/fc_link";

// eslint-disable-next-line
class PlaylistPage extends Component {
  constructor() {
    super();
    this.renderVideoCard = this.renderVideoCard.bind(this);
  }

  renderVideoCard (videoData, config) {
      return <Card
        config={config}
        key={videoData.mediaid}
        type="all-feed"
        metadata={{
          link:  `/video/${videoData.slug}/${videoData.mediaid}`,
          title: videoData.title,
          excerpt: videoData.description,
          layout: 'long',
          featured_image: {
            source: videoData.image
          }
        }}
      />;
  }

  render() {
    if (this.props.status === 404 || this.props.status === 500) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.playlistPage.isLoading) {
      return (
        <section className="playlist-page">
          <article className="playlist-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const config = get(this.props, 'config', {});
    const playlistTitle = get(this.props, 'match.params.playlistTitle', '');
    const playlistId = get(this.props, 'match.params.playlistId', 0);
    const page = get(this.props, 'match.params.page', false);
    const lastPage = get(this.props, 'jwPlaylist.data.lastPage');
    const nextPage = Number(page) + 1 === 1 ? 2 : Number(page) + 1;
    const previousPage = Number(page) - 1;
    const shouldShowNext = Number(page) < lastPage;
    const shouldShowPrevious = page && (Number(page) - 1 !== 0);
    const nextLink= `/videos/playlist/${playlistTitle}/${playlistId}/${nextPage}`;
    const previousLink = (Number(page) - 1 === 1) ? `/videos/playlist/${playlistTitle}/${playlistId}` : `/videos/playlist/${playlistTitle}/${playlistId}/${previousPage}`;
    return (
      <section className={`tag-page`}>
        <section className="page-title">
          <Slug
            slugName={`${get(this.props, 'jwPlaylist.data.title')} ${page ? `Page ${page}` : ''}`}
            className="category-page"
          />
        {shouldShowPrevious && <FCLink config={config} title={`TODO: title`} to={previousLink}>PREVIOUS PAGE</FCLink>}
          {shouldShowNext && <FCLink config={config} title={`TODO: title`} to={nextLink}>NEXT PAGE</FCLink>}
          <p>{`${get(this.props, 'jwPlaylist.data.description')}`}</p>
          {
            get(this.props, 'jwPlaylist.data.playlist', [])
            .map(videoData => this.renderVideoCard(videoData, config))
          }
        </section>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    playlistPage: state.playlistPage,
    jwPlaylist: state.jwPlaylist
  };
}

PlaylistPage.propTypes = {
  config: PropTypes.shape({}).isRequired,
  status: PropTypes.number,
  playlistPage: PropTypes.shape({}),
  jwPlaylist: PropTypes.shape({})
};

export default withRouter(connect(mapStateToProps)(PlaylistPage));



// WEBPACK FOOTER //
// ./src/views/containers/pages/video/playlist_page/playlist_page.js